import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { CodeSnippetService } from '@services/code-snippets/code-snippet.service';
import { MemoryService } from '@services/memory/memory.service';
import { DataTableComponent, DataTableEvent } from '../../../../components/data-table/data-table.component';
import moment from 'moment';

@Component({
    selector: 'composition-wizard-code-snippets',
    templateUrl: './composition-wizard-code-snippets.component.html',
    styleUrls: ['./composition-wizard-code-snippets.component.scss'],
    providers: [CodeSnippetService],
    standalone: false
})
export class CompositionWizardCodeSnippetsComponent implements OnInit {

  @ViewChild('assignedCodeSnippetsTable') assignedCodeSnippetsTable: DataTableComponent;
  @Input() composition: Models.Composition;
  public columns = [{ prop: 'title' }];
  public params = { type: 'json' };
  public assignedCodeSnippetsProvider: MemoryService<Models.CodeSnippet>;
  private assignedCodeSnippets: Models.CodeSnippet[];

  constructor(public codeSnippetService: CodeSnippetService) {
  }

  async ngOnInit() {
    this.assignedCodeSnippets = [];
    this.assignedCodeSnippetsProvider = new MemoryService(this.assignedCodeSnippets);

    if (!!this.composition?.snippetIds?.length) {
      const response = await this.codeSnippetService.find(0, 100, { _id: { $in: this.composition.snippetIds } });
      this.assignedCodeSnippets = response.data;
      this.updateAssignedCodeSnippets();
    }
  }

  public async assignImport(event: DataTableEvent) {
    if (this.assignedCodeSnippets.find(c => c?._id === event?.row?._id)) {
      return;
    }
    const snippet = await this.codeSnippetService.get(event.row._id);
    this.assignedCodeSnippets.push(snippet);
    this.updateAssignedCodeSnippets();
  }

  public removeAssignedCodeSnippet(event: DataTableEvent): void {
    this.assignedCodeSnippets.splice(event.index, 1);
    this.updateAssignedCodeSnippets();
  }

  private updateAssignedCodeSnippets(): void {
    this.composition.snippetIds = this.assignedCodeSnippets.map(s => s._id);
    this.assignedCodeSnippetsProvider.db = this.assignedCodeSnippets;
    this.assignedCodeSnippetsTable.refresh();
  }

}
